import {wrapPromise} from '../hooks/useSuspense'
import {jwtGetFetcher} from '../utils/authFetch'
import {getJwt} from '../hooks/useJwt'


export const lazyProviderInfo = wrapPromise(() => {
  if (import.meta.env.MODE === 'printer') {
    return Promise.resolve({locale: 'en-US'})
  } else {
    return jwtGetFetcher()("/api/providerInfo")
  }
})

// Secure provider info, only accessible with JWT
export const lazyProviderInfoSec = wrapPromise(() => jwtGetFetcher(getJwt())("/api/providerInfoSec"))

export const lazyUserInfo = wrapPromise(() => jwtGetFetcher(getJwt())("/api/userInfo"))
export const lazyMaybeUserInfo = wrapPromise(() => jwtGetFetcher(getJwt())("/api/userInfo").catch(e => {
  if (e && e[1] && (e[1].status === 401 || e[1].status === 403 || e[1].status === 404)) {
    return null
  } else {
    return Promise.reject(e)
  }
}))
